import { RECEIVE_LOGIN_ASSISTANT_CONTENT } from 'store/ducks/loginAssistant/types';
import { markdownToHtml } from 'helpers/HtmlHelpers';

const defaultContent = {
  bubbleContent: '',
  ctaText: '',
  ctaLink: '',
  retrieved: false,
  isEmpty: true
};

const defaultState = {
  content: defaultContent
};

export default function loginAssistant(state = defaultState, action = {}) {
  const { type, content } = action;
  switch (type) {
    case RECEIVE_LOGIN_ASSISTANT_CONTENT:
      const curedContent = content || {};
      const isEmpty = !curedContent.bubbleContent;
      const newContent = {
        ...defaultContent,
        ...curedContent,
        retrieved: true,
        isEmpty
      };

      newContent.bubbleContent = markdownToHtml(newContent.bubbleContent || '');

      return {
        ...state,
        content: newContent
      };
    default:
      return state;
  }
}
